import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ProductApiResponse, ProductSearchParams } from '@/core/models/api/concreto-product-api-model.model';
import { Observable } from 'rxjs';
import {  CreateConcretoTender } from '../models/concreto/concreto-tender.model';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private concretoApiEndPoint = `${environment.concretoApiEndPoint}/`;  // Quité la barra final

  constructor(private http: HttpClient) { }

  /**
   * Obtiene productos/recursos desde la API
   * @param params Parámetros de búsqueda
   * @returns Observable con la respuesta de la API
   */
  getProducts(params: ProductSearchParams = {}): Observable<ProductApiResponse> {
    // Puedes usar GET o POST según prefieras, la API acepta ambos
    return this.http.get<ProductApiResponse>(`${this.concretoApiEndPoint}informacion/api/products/`, {
      params: this.buildParams(params)
    });
  }

  /**
   * Búsqueda de productos usando POST
   * @param params Parámetros de búsqueda
   * @returns Observable con la respuesta de la API
   */
  searchProducts(params: ProductSearchParams = {}): Observable<ProductApiResponse> {
    console.log('Sending POST request to:', this.concretoApiEndPoint);
    console.log('With params:', params);
    return this.http.post<ProductApiResponse>(`${this.concretoApiEndPoint}informacion/api/products/`, params);
  }

  /**
   * Construye los parámetros HTTP para la solicitud GET
   */
  private buildParams(params: ProductSearchParams): HttpParams {
    let httpParams = new HttpParams();

    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.exact !== undefined) httpParams = httpParams.set('exact', params.exact.toString());
    if (params.organization_id) httpParams = httpParams.set('organization_id', params.organization_id.toString());
    if (params.category) httpParams = httpParams.set('category', params.category);
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.page_size) httpParams = httpParams.set('page_size', params.page_size.toString());
    if (params.ciudad) httpParams = httpParams.set('ciudad', params.ciudad);
    if (params.provincia) httpParams = httpParams.set('provincia', params.provincia);

    return httpParams;
  }

  createTender(tender: CreateConcretoTender) {
    return this.http.post(`${this.concretoApiEndPoint}requisiciones/api/crear_requisicion/`, tender);
  }
}